var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerceptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.783,
    height: 43.783,
    viewBox: "0 0 43.783 43.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perceptionIcon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    width: 43.783,
    height: 43.783,
    transform: "translate(0 0)",
    fill: "#F3CA4E",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26312",
    d: "M36.512,17.086a22.747,22.747,0,0,0-32.112,0,1.377,1.377,0,1,0,1.947,1.947,19.964,19.964,0,0,1,28.218,0,1.377,1.377,0,1,0,1.947-1.947Zm-5.087,8.062a20.1,20.1,0,0,1-14.987,2.879,1.4,1.4,0,0,0-.548,2.742,22.816,22.816,0,0,0,17.043-3.291,1.388,1.388,0,1,0-1.508-2.331Zm-19.662,1.3a22.309,22.309,0,0,1-2.276-1.3,1.371,1.371,0,0,0-1.508,2.276,21.5,21.5,0,0,0,2.605,1.495,1.289,1.289,0,0,0,.59.137,1.371,1.371,0,0,0,.59-2.605Z",
    transform: "translate(1.483 3.786)",
    fill: "#F3CA4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26313",
    d: "M18.988,29.052A5.485,5.485,0,1,0,13.5,23.567,5.485,5.485,0,0,0,18.988,29.052Zm0-8.227a2.742,2.742,0,1,1-2.742,2.742A2.742,2.742,0,0,1,18.988,20.825Zm0-10.969a1.371,1.371,0,0,0,1.371-1.371V4.371a1.371,1.371,0,1,0-2.742,0V8.485A1.371,1.371,0,0,0,18.988,9.856Zm6.856,1.371a1.371,1.371,0,0,0,1.138-.617L29.724,6.5a1.371,1.371,0,1,0-2.276-1.508L24.706,9.1a1.371,1.371,0,0,0,.384,1.892A1.289,1.289,0,0,0,25.844,11.227Zm-14.85-.617a1.371,1.371,0,0,0,1.138.617,1.289,1.289,0,0,0,.754-.233A1.371,1.371,0,0,0,13.271,9.1L10.528,4.988A1.371,1.371,0,1,0,8.252,6.5Z",
    transform: "translate(2.95 1.02)",
    fill: "#F3CA4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerceptionIcon);
export default __webpack_public_path__ + "static/media/perception-icon.3c5357ab059439c6aa2b63736aa35688.svg";
export { ForwardRef as ReactComponent };